import {
  BellIcon,
  BlackRightIcon,
  ClaenderIcon,
  EditIcon,
  ErroeIcon,
  MarkCompletedIcon,
  MembersIcon,
  StatusLevelIcon,
  WorkflowItemDeleteIcon,
  WorkflowItemRightArrow,
} from "./Icon";
import ContactIcon from "../../assets/images/svg/contact-icon.svg";
import followUpsIcon from "../../assets/images/svg/followUps-icon.svg";
import scheduledMeetingIcon from "../../assets/images/svg/scheduledMeeting-icon.svg";
import reconnectsIcon from "../../assets/images/svg/reconnects-icon.svg";

// Todays-Workflow
import bessieCooper from "../../assets/images/today-workflow/bessie_cooper_img.svg";
import floydMiles from "../../assets/images/today-workflow/floyd_miles_img.svg";
import ralphEdwards from "../../assets/images/today-workflow/ralph_edwards_img.svg";
import jennyWilson from "../../assets/images/today-workflow/jenny_wilson_img.svg";
import kathrynMurphy from "../../assets/images/today-workflow/kathryn_murphy_img.svg";
import bessieCooper2 from "../../assets/images/today-workflow/bessie_cooper2_img.svg";

// Todays-Workflow-Item
import googleDuoIcon from "../../assets/images/today-workflow/google_duo_icon.svg";
import googleMeetIcon from "../../assets/images/today-workflow/google_meet_icon.svg";
// Todays-My-Schedule
import MyScheduleVideoIcon from "../../assets/images/today-workflow/google_meet_icon.svg";
import MyScheduleVideoIcondeo from "../../assets/images/today-workflow/google_duo_icon.svg";
// MY TEAM MEMBERS IMG DATA
import TradingSceretsImg from "../../assets/images/svg/trading-scerets-img.svg";
import HeadHouseImg from "../../assets/images/svg/Head-house-img.svg";
import SltImg from "../../assets/images/svg/slt-img.svg";
import PastroalImg from "../../assets/images/svg/pastroal-staff-img.svg";
import AcademicTutorsImg from "../../assets/images/svg/Academic-Tutors-img.svg";
import HeadsYearImg from "../../assets/images/svg/Heads-Year.svg";
import MathsTeamImg from "../../assets/images/svg/Maths-Team.svg";

// MY CONTACT IMG DATA
import bessieCopperImg from "../../assets/images/my-contact-img/bessie-copper-img.svg";
import JaneCooperImg from "../../assets/images/my-contact-img/Jane-Cooper-img.svg";
import CameronWilliamsonImg from "../../assets/images/my-contact-img/Cameron-Williamson-img.svg";
import TheresaWebbImg from "../../assets/images/my-contact-img/Theresa-Webb-img.svg";
import AnnetteBlackImg from "../../assets/images/my-contact-img/Annette-Black-img.svg";
import AlberFloresImg from "../../assets/images/my-contact-img/Alber-Flores-img.svg";
import EstherHowardImg from "../../assets/images/my-contact-img/Esther-Howard-img.svg";
import JeromeBellImg from "../../assets/images/my-contact-img/Jerome-Bell-img.svg";
import RobertFoxImg from "../../assets/images/my-contact-img/Robert-Fox-img.svg";
//  BLOG IMG DATA
import BlogImg1 from "../../assets/images/blog-img/blog-img-1.webp";
import BlogImg2 from "../../assets/images/blog-img/blog-img-2.webp";
import BlogImg3 from "../../assets/images/blog-img/blog-img-3.webp";
import BlogImg4 from "../../assets/images/blog-img/blog-img-4.webp";
import BlogImg5 from "../../assets/images/blog-img/blog-img-5.webp";
import BlogImg6 from "../../assets/images/blog-img/blog-img-6.webp";
//  CHATA IMG DATA
import ChataImg1 from "../../assets/images/chata-img/chata-img-1.webp";
import ChataImg2 from "../../assets/images/chata-img/chata-img-2.webp";
import ChataImg3 from "../../assets/images/chata-img/chata-img-3.webp";
import ChataImg4 from "../../assets/images/chata-img/chata-img-4.webp";
import ChataImg5 from "../../assets/images/chata-img/chata-img-5.webp";
import ChataImg6 from "../../assets/images/chata-img/chata-img-6.webp";
//  Logout IMG DATA
import logoutImg1 from "../../assets/images/png/logout-img-1.png";
//  ALL CONACTACTS
import addCustomColorImg from "../../assets/images/svg/add-custom-color-img.svg";
export const TodayProductivityCards = [
  {
    similarIcon: ContactIcon,
    contactpercent: "25",
    para: "New Contacts",
    className: "Progress_color1",
    para2: "10 new contacts",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: followUpsIcon,
    contactpercent: "75",
    para: "Follow Ups",
    className: "Progress_color2",
    para2: "5 follow ups",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: scheduledMeetingIcon,
    contactpercent: "20",
    para: "Scheduled Meeting",
    className: "Progress_color3",
    para2: "10 scheduled meetings",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: reconnectsIcon,
    contactpercent: "10",
    para: "Reconnects",
    className: "Progress_color4",
    para2: "10 reconnects",
    editIcon: <EditIcon />,
  },
];
// TEAM GOALS CARDS ===========
export const TodayTeamGoalsCards = [
  {
    similarIcon: ContactIcon,
    contactpercent: "25%",
    para: "New Contacts",
    className: "Progress_color1 w-[25%]",
    para2: "10 new contacts",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: followUpsIcon,
    contactpercent: "75%",
    para: "Follow Ups",
    className: "Progress_color2 w-[75%]",
    para2: "5 follow ups",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: scheduledMeetingIcon,
    contactpercent: "20%",
    para: "Scheduled Meeting",
    className: "Progress_color3 w-[20%]",
    para2: "10 scheduled meetings",
    editIcon: <EditIcon />,
  },
  {
    similarIcon: reconnectsIcon,
    contactpercent: "10%",
    para: "Reconnects",
    className: "Progress_color4 w-[10%]",
    para2: "10 reconnects",
    editIcon: <EditIcon />,
  },
];

// Todays-Workflow New-Contacts-Data
export const todayWorkflowContactData = [
  {
    newContactImg: bessieCooper,
    newContactNameText: "Bessie Cooper",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 3",
    newContactLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-green",
    newContactLabelBtnBgColor: "bg-graf",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
  {
    newContactImg: floydMiles,
    newContactNameText: "Floyd Miles",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 1",
    newContactLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-green",
    newContactLabelBtnBgColor: "bg-new_bule",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
  {
    newContactImg: ralphEdwards,
    newContactNameText: "Ralph Edwards",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 3",
    newContactLabelBtn: "Team Member",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-skyblue",
    newContactLabelBtnBgColor: "bg-new_purpal",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
  {
    newContactImg: jennyWilson,
    newContactNameText: "Jenny Wilson",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 1",
    newContactLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-redish",
    newContactLabelBtnBgColor: "bg-graf",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
  {
    newContactImg: kathrynMurphy,
    newContactNameText: "Kathryn Murphy",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 3",
    newContactLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-yellow",
    newContactLabelBtnBgColor: "bg-new_bule",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
  {
    newContactImg: bessieCooper2,
    newContactNameText: "Bessie Cooper",
    newContactStatusIcon: <StatusLevelIcon />,
    newContactTeamLevelText: "Level 2",
    newContactLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    levelTextColor: "text-skyblue",
    newContactLabelBtnBgColor: "bg-new_pink",
    newContactModeltext: "Do you want to delete the new contacts?",
  },
];

// Todays-Workflow FollowUps Data
export const todayWorkflowFollowUpData = [
  {
    newContactImg: bessieCooper,
    newContactNameText: "Bessie Cooper",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-graf",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
  {
    newContactImg: floydMiles,
    newContactNameText: "Floyd Miles",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-new_bule",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
  {
    newContactImg: ralphEdwards,
    newContactNameText: "Ralph Edwards",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Team Member",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-new_purpal",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
  {
    newContactImg: jennyWilson,
    newContactNameText: "Jenny Wilson",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-graf",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
  {
    newContactImg: kathrynMurphy,
    newContactNameText: "Kathryn Murphy",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-new_bule",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
  {
    newContactImg: bessieCooper2,
    newContactNameText: "Bessie Cooper",
    followUptatusIcon: <StatusLevelIcon />,
    followUpLevelText: "Level 3",
    followUpLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    followUpLevelTextColor: "text-green",
    followUpLabelBtnBgColor: "bg-new_pink",
    followUpModeltext: "Do you want to delete the follow-up?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "09/11/22",
    markCompletedModelHeading: "Mark follow up completed",
  },
];
// Logout Conatct FollowUps Data
export const LogoutContactData = [
  {
    logoutimg: logoutImg1,
    logoutheading: "Jenny Wilson",
    logoutbtn: "Clients",
    logoutFollow: "Missed  Follow Up On:",
    logoutDate: "Apr 5th",
    LogoutBtnBgColor: "bg-graf",
    logoutErrorIcon: <ErroeIcon />,
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Floyd Miles",
    logoutbtn: "Team Member",
    logoutFollow: "Follow Up On:",
    logoutDate: " Nov 1st",
    LogoutBtnBgColor: "bg-new_purpal",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Ralph Edwards",
    logoutbtn: "Prospect",
    logoutFollow: "Missed Follow Up On: ",
    logoutDate: "Nov 3rd",
    LogoutBtnBgColor: "bg-new_bule",
    logoutErrorIcon: <ErroeIcon />,
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Bessie Cooper ",
    logoutbtn: "Clients",
    logoutFollow: "Follow Up On: ",
    logoutDate: "Oct 31st",
    LogoutBtnBgColor: "bg-graf",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Kathryn Murphy",
    logoutbtn: "Team Member",
    logoutFollow: "Follow Up On: ",
    logoutDate: "Dec 1st",
    LogoutBtnBgColor: "bg-new_purpal",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Wade Warren",
    logoutbtn: "Clients",
    logoutFollow: "Follow Up On:",
    logoutDate: "Mar 5th",
    LogoutBtnBgColor: "bg-graf",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Dianne Russell",
    logoutbtn: "Team Member",
    logoutFollow: "Follow Up On:",
    logoutDate: "Oct 31st",
    LogoutBtnBgColor: "bg-new_purpal",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Arlene McCoy",
    logoutbtn: "Team Member",
    logoutFollow: "Follow Up On:",
    logoutDate: " Jun 2nd",
    LogoutBtnBgColor: "bg-new_purpal",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Darlene Robertson",
    logoutbtn: "Prospect",
    logoutFollow: "Follow Up On:",
    logoutDate: "Oct 31st",
    LogoutBtnBgColor: "bg-new_bule",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
  {
    logoutimg: logoutImg1,
    logoutheading: "Theresa Webb",
    logoutbtn: "Clients",
    logoutFollow: "Follow Up On: ",
    logoutDate: "Oct 31st",
    LogoutBtnBgColor: "bg-graf",
    logoutdelete: <WorkflowItemDeleteIcon />,
    rightArrow: <BlackRightIcon />,
    contactModeltext: "Do you want to delete the contacts?",
  },
];

// Todays-Workflow Meeting Data
export const todayWorkflowMeetingData = [
  {
    newContactImg: bessieCooper,
    newContactNameText: "Bessie Cooper",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: " Level 3",
    meetingLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-graf",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleDuoIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
  {
    newContactImg: floydMiles,
    newContactNameText: "Floyd Miles",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: "Level 3",
    meetingLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-new_bule",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleMeetIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
  {
    newContactImg: ralphEdwards,
    newContactNameText: "Ralph Edwards",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: "Level 3",
    meetingLabelBtn: "Team Member",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-new_purpal",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleMeetIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
  {
    newContactImg: jennyWilson,
    newContactNameText: "Jenny Wilson",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: "Level 3",
    meetingLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-graf",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleDuoIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
  {
    newContactImg: kathrynMurphy,
    newContactNameText: "Kathryn Murphy",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: "Level 3",
    meetingLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-new_bule",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleMeetIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
  {
    newContactImg: bessieCooper2,
    newContactNameText: "Bessie Cooper",
    meetingStatusIcon: <StatusLevelIcon />,
    meetingLevelText: "Level 3",
    meetingLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    meetingLevelTextColor: "text-green",
    meetingLabelBtnBgColor: "bg-new_pink",
    meetingModeltext: "Do you want to delete the meeting?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "09/11/22",
    meetingAppIcon: googleDuoIcon,
    markCompletedModelHeading: "Mark meeting completed",
  },
];

// Todays-Workflow Reconnects Data
export const todayWorkflowReconnectData = [
  {
    newContactImg: bessieCooper,
    newContactNameText: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-graf",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    newContactImg: floydMiles,
    newContactNameText: "Floyd Miles",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 1",
    reconnectLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-new_bule",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    newContactImg: ralphEdwards,
    newContactNameText: "Ralph Edwards",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Team Member",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-skyblue",
    reconnectLabelBtnBgColor: "bg-new_purpal",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    newContactImg: jennyWilson,
    newContactNameText: "Jenny Wilson",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 1",
    reconnectLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-redish",
    reconnectLabelBtnBgColor: "bg-graf",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    newContactImg: kathrynMurphy,
    newContactNameText: "Kathryn Murphy",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-yellow",
    reconnectLabelBtnBgColor: "bg-new_bule",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    newContactImg: bessieCooper2,
    newContactNameText: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-skyblue",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
];
// Set-Todays productivity Data
export const MyTeammatesProductivity = [
  {
    teammatesImg: bessieCooper,
    teammatesNameText: "Bessie Cooper",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 3",
    levelTextColor: "text-green",
    fullDate: "09/11/22",
  },
  {
    teammatesImg: floydMiles,
    teammatesNameText: "Floyd Miles",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 1",
    levelTextColor: "text-green",
    fullDate: "09/11/22",
  },
  {
    teammatesImg: ralphEdwards,
    teammatesNameText: "Ralph Edwards",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 3",
    levelTextColor: "text-skyblue",
    fullDate: "09/11/22",
  },
  {
    teammatesImg: jennyWilson,
    teammatesNameText: "Jenny Wilson",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 1",
    levelTextColor: "text-redish",
    fullDate: "09/11/22",
  },
  {
    teammatesImg: kathrynMurphy,
    teammatesNameText: "Kathryn Murphy",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 3",
    levelTextColor: "text-yellow",
    fullDate: "09/11/22",
  },
  {
    teammatesImg: bessieCooper2,
    teammatesNameText: "Bessie Cooper",
    teammatesStatusIcon: <StatusLevelIcon />,
    teammatesTeamLevelText: "Level 2",
    levelTextColor: "text-skyblue",
    fullDate: "09/11/22",
  },
];
// Set-Todays productivity MyTeamFollowUps Data
export const MyTeamsFollowsupsProductivity = [
  {
    folllowupsImg: bessieCooper,
    followupsNameText: "Bessie Cooper",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 3",
    levelTextColor: "text-green",
    fullDate: "09/11/22",
  },
  {
    folllowupsImg: floydMiles,
    followupsNameText: "Floyd Miles",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 1",
    levelTextColor: "text-green",
    fullDate: "09/11/22",
  },
  {
    folllowupsImg: ralphEdwards,
    followupsNameText: "Ralph Edwards",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 3",

    levelTextColor: "text-skyblue",
    fullDate: "09/11/22",
  },
  {
    folllowupsImg: jennyWilson,
    followupsNameText: "Jenny Wilson",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 1",
    levelTextColor: "text-redish",
    fullDate: "09/11/22",
  },
  {
    folllowupsImg: kathrynMurphy,
    followupsNameText: "Kathryn Murphy",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 3",
    levelTextColor: "text-yellow",
    fullDate: "09/11/22",
  },
  {
    folllowupsImg: bessieCooper2,
    followupsNameText: "Bessie Cooper",
    followupsStatusIcon: <StatusLevelIcon />,
    followupsTeamLevelText: "Level 2",
    levelTextColor: "text-skyblue",
    fullDate: "09/11/22",
  },
];
// Set-Todays productivity MyTeamFollowUps Data
export const MyScheduleProductivity = [
  {
    myscheduleupsImg: bessieCooper,
    myscheduleNameText: "Bessie Cooper",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 3",
    levelTextColor: "text-green",
    myschedulevideoicon: MyScheduleVideoIcon,
    fullDate: "09/11/22",
  },
  {
    myscheduleupsImg: floydMiles,
    myscheduleNameText: "Floyd Miles",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 1",
    levelTextColor: "text-green",
    myschedulevideoicon: MyScheduleVideoIcondeo,
    fullDate: "09/11/22",
  },
  {
    myscheduleupsImg: ralphEdwards,
    myscheduleNameText: "Ralph Edwards",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 3",
    levelTextColor: "text-skyblue",
    myschedulevideoicon: MyScheduleVideoIcon,
    fullDate: "09/11/22",
  },
  {
    myscheduleupsImg: jennyWilson,
    myscheduleNameText: "Jenny Wilson",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 1",
    levelTextColor: "text-redish",
    myschedulevideoicon: MyScheduleVideoIcon,
    fullDate: "09/11/22",
  },
  {
    myscheduleupsImg: kathrynMurphy,
    myscheduleNameText: "Kathryn Murphy",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 3",
    levelTextColor: "text-yellow",
    myschedulevideoicon: MyScheduleVideoIcon,
    fullDate: "09/11/22",
  },
  {
    myscheduleupsImg: bessieCooper2,
    myscheduleNameText: "Bessie Cooper",
    myscheduleStatusIcon: <StatusLevelIcon />,
    myscheduleTeamLevelText: "Level 2",
    levelTextColor: "text-skyblue",
    myschedulevideoicon: MyScheduleVideoIcondeo,
    fullDate: "09/11/22",
  },
];
// ===== TEAM PROGRESS TABEL
export const ModemsTabelRow = [
  {
    dataName: "Teammates Name",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "New contacts",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "Follow Ups",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "Meeting",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "Reconnect",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData1 = [
  {
    dataName: "Leslie Alexander",
    text: "(0504)",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "1",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "5",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "3",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData2 = [
  {
    dataName: "Savannah Nguyen",
    text2: "4",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "5",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "3",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData3 = [
  {
    dataName: "Dianne Russell",
    text3: "(0050)",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "10",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "3",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "10",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData4 = [
  {
    dataName: "Darlene Robertson",
    text3: "(0050)",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "3",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "5",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData5 = [
  {
    dataName: "Ronald Richards",
    text3: "(0050)",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "1",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "2",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "7",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "5",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
export const ModemsTabelData6 = [
  {
    dataName: "Total",
    text3: "(0050)",
    tabelRowStyle: "w-[130px] , text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "11",
    tabelRowStyle: "w-[120px] text-center text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "24",
    tabelRowStyle: "w-[102px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "17",
    tabelRowStyle: "w-[117px] text-[#333333]",
    headingRowStyle: "border-r border-solid border-[#f2f2f2]",
    hide: "hidden",
  },
  {
    dataName: "25",
    tabelRowStyle: "w-[109px] text-[#333333]",
    headingRowStyle: "",
    hide: "hidden",
  },
];
// ====  MY TEAM MEMBERS DATA
export const MyTeamsMemeberData = [
  {
    memberimg: TradingSceretsImg,
    membertext: "Trading - Secrets",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "6 members",
  },
  {
    memberimg: HeadHouseImg,
    membertext: "Heads of houses",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "2 members",
  },
  {
    memberimg: SltImg,
    membertext: "SLT",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "5 members",
  },
  {
    memberimg: PastroalImg,
    membertext: "Pastoral staff",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "4 members",
  },
  {
    memberimg: AcademicTutorsImg,
    membertext: "Academic Tutors",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "6 members",
  },
  {
    memberimg: HeadsYearImg,
    membertext: "Heads of year",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "3 members",
  },
  {
    memberimg: MathsTeamImg,
    membertext: "Maths Team",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "7 members",
  },
  {
    memberimg: TradingSceretsImg,
    membertext: "Trading - Secrets",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "8 members",
  },
  {
    memberimg: TradingSceretsImg,
    membertext: "Trading - Secrets",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "6 members",
  },
  {
    memberimg: TradingSceretsImg,
    membertext: "Trading - Secrets",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "5 members",
  },
  {
    memberimg: TradingSceretsImg,
    membertext: "Trading - Secrets",
    memberbtnicon: <MembersIcon />,
    memberbtntext: "7 members",
  },
];
// ====  MY CONTACT RECENTS DATA
export const MyContactRecentData = [
  {
    memberimg: bessieCopperImg,
    membertext: "Bessie Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JaneCooperImg,
    membertext: "Jane Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: CameronWilliamsonImg,
    membertext: "Cameron Williamson",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: TheresaWebbImg,
    membertext: "Theresa Webb",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AnnetteBlackImg,
    membertext: "Annette Black",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AlberFloresImg,
    membertext: "Albert Flores",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: EstherHowardImg,
    membertext: "Esther Howard",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JeromeBellImg,
    membertext: "Jerome Bell",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: RobertFoxImg,
    membertext: "Robert Fox",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
];
export const MyContactHighFrequentData = [
  {
    memberimg: JaneCooperImg,
    membertext: "Jane Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: CameronWilliamsonImg,
    membertext: "Cameron Williamson",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: bessieCopperImg,
    membertext: "Bessie Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: TheresaWebbImg,
    membertext: "Theresa Webb",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JeromeBellImg,
    membertext: "Jerome Bell",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: RobertFoxImg,
    membertext: "Robert Fox",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AnnetteBlackImg,
    membertext: "Annette Black",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AlberFloresImg,
    membertext: "Albert Flores",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: EstherHowardImg,
    membertext: "Esther Howard",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
];
export const MyContactLowFrequentData = [
  {
    memberimg: bessieCopperImg,
    membertext: "Bessie Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AnnetteBlackImg,
    membertext: "Annette Black",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AlberFloresImg,
    membertext: "Albert Flores",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JaneCooperImg,
    membertext: "Jane Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: CameronWilliamsonImg,
    membertext: "Cameron Williamson",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: TheresaWebbImg,
    membertext: "Theresa Webb",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },

  {
    memberimg: EstherHowardImg,
    membertext: "Esther Howard",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JeromeBellImg,
    membertext: "Jerome Bell",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: RobertFoxImg,
    membertext: "Robert Fox",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
];
export const MyContactReconnets = [
  {
    memberimg: TheresaWebbImg,
    membertext: "Theresa Webb",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AnnetteBlackImg,
    membertext: "Annette Black",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: AlberFloresImg,
    membertext: "Albert Flores",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: EstherHowardImg,
    membertext: "Esther Howard",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: bessieCopperImg,
    membertext: "Bessie Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JaneCooperImg,
    membertext: "Jane Cooper",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: CameronWilliamsonImg,
    membertext: "Cameron Williamson",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: JeromeBellImg,
    membertext: "Jerome Bell",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
  {
    memberimg: RobertFoxImg,
    membertext: "Robert Fox",
    ContactTeamLevelText: "Level 1",
    ContactStatusIcon: <StatusLevelIcon />,
    markCompleteIcon: <MarkCompletedIcon />,
    ContactFullDate: "09/11/22",
  },
];
export const AllConatctData = [
  {
    reconnectImg: bessieCooper,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-skyblue",
    reconnectLabelBtnBgColor: "bg-graf",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: floydMiles,
    reconnectTeamName: "Floyd Miles",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 1",
    reconnectLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-new_bule",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: ralphEdwards,
    reconnectTeamName: "Ralph Edwards",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Team Member",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-skyblue",
    reconnectLabelBtnBgColor: "bg-new_purpal",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: jennyWilson,
    reconnectTeamName: "Jenny Wilson",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 1",
    reconnectLabelBtn: "Clients",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-graf",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: kathrynMurphy,
    reconnectTeamName: "Kathryn Murphy",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 3",
    reconnectLabelBtn: "Prospect",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-skyblue",
    reconnectLabelBtnBgColor: "bg-new_bule",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: bessieCooper2,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-yellow",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: bessieCooper2,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: bessieCooper2,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: bessieCooper2,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-green",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
  {
    reconnectImg: bessieCooper2,
    reconnectTeamName: "Bessie Cooper",
    reconnectStatusIcon: <StatusLevelIcon />,
    reconnectLevelText: "Level 2",
    reconnectLabelBtn: "Add New Type",
    deleteWorkflowIcon: <WorkflowItemDeleteIcon />,
    rightArrow: <WorkflowItemRightArrow />,
    reconnectLevelTextColor: "text-yellow",
    reconnectLabelBtnBgColor: "bg-new_pink",
    reconnectModeltext: "Do you want to delete the reconnect?",
    followUpOnText: "Follow Up On:",
    followUpOnDate: "Oct 31st",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    reconnectFullDate: "09/11/22",
    markCompletedModelHeading: "Mark reconnect completed",
  },
];
// =========  BLOG CONTENT DATA
export const BlogContenDtata = [
  {
    blogimg1: BlogImg1,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    blogimg1: BlogImg2,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    blogimg1: BlogImg3,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    blogimg1: BlogImg4,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    blogimg1: BlogImg5,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    blogimg1: BlogImg6,
    blogheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogbtn: "Read More",
    blogheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    blogpar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    blogpara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blogpara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    blogpara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    blogpara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
];
// =========  CHATAVIRSITY CONTENT DATA
export const ChatavirsityContentData = [
  {
    chataimg1: ChataImg1,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    chataimg1: ChataImg2,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    chataimg1: ChataImg3,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    chataimg1: ChataImg4,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    chataimg1: ChataImg5,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    chataimg1: ChataImg6,
    chataheading:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapara:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatabtn: "Read More",
    chataheading2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chataheading3:
      "The Importance Of Follow Ups and How to teach your team an easy method.",
    chatapar2:
      "We notice that your team has a lower amount of new clients coming in. We think that this blog may help you help your team!",
    chatapara3:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    chatapara4:
      "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    chatapara5:
      "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    chatapara6:
      "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
];

// Workflow Profile FollowUp Data
export const workflowProfileFollowUpData = [
  {
    followUpImg: floydMiles,
    followUpNameText: "Floyd Miles",
    followUpModeltext: "Do you want to delete the follow-up?",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "9 Aug 2023",
    markCompletedModelHeading: "Mark follow up completed",
    followTime: "3:30PM",
  },
  {
    followUpImg: ralphEdwards,
    followUpNameText: "Ralph Edwards",
    followUpModeltext: "Do you want to delete the follow-up?",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "9 Aug 2023",
    markCompletedModelHeading: "Mark follow up completed",
    followTime: "3:30PM",
  },
  {
    followUpImg: jennyWilson,
    followUpNameText: "Jenny Wilson",
    followUpModeltext: "Do you want to delete the follow-up?",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "9 Aug 2023",
    markCompletedModelHeading: "Mark follow up completed",
    followTime: "3:30PM",
  },

  {
    followUpImg: bessieCooper2,
    followUpNameText: "Bessie Cooper",
    followUpModeltext: "Do you want to delete the follow-up?",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    followUpFullDate: "9 Aug 2023",
    markCompletedModelHeading: "Mark follow up completed",
    followTime: "3:30PM",
  },
];

// CREATE FOLLOW-UP POP-UP DATA

export const createFollowUpPopUpData = [
  {
    createFollowUpImg: bessieCooper,
    svgIcon: <ClaenderIcon />,
    createFollowUpNameText: "Bessie Cooper",
  },
  {
    createFollowUpImg: floydMiles,
    svgIcon: <ClaenderIcon />,
    createFollowUpNameText: "Beeta",
  },
  {
    createFollowUpImg: ralphEdwards,
    svgIcon: <ClaenderIcon />,
    createFollowUpNameText: "Bell Jerome",
  },
  {
    createFollowUpImg: jennyWilson,
    svgIcon: <ClaenderIcon />,
    createFollowUpNameText: "Benny Edwards",
  },
  {
    createFollowUpImg: kathrynMurphy,
    svgIcon: <ClaenderIcon />,
    createFollowUpNameText: "Bobbi Wilson",
  },
];

// Workflow Profile Meeting Data
export const workflowProfileMeetingData = [
  {
    markCompletedModelHeading: "Mark meeting completed",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "9 Aug 2023",
    meetingTime: "3:30PM",
    upcomingBtn: "Upcoming",
    meetingText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    markCompletedModelHeading: "Mark meeting completed",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "15 Aug 2023",
    meetingTime: "5:00PM",
    upcomingBtn: "Upcoming",
    meetingText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    markCompletedModelHeading: "Mark meeting completed",
    markCompleteBtn: "Mark Completed",
    markCompleteIcon: <MarkCompletedIcon />,
    meetingFullDate: "5 Nov 2023",
    meetingTime: "2:30PM",
    upcomingBtn: "Upcoming",
    meetingText:
      "I contacted them on facebook messenger regarding their order status.",
  },
];

// Workflow Profile FollowUps Data
export const profileContactLogFollowUpsData = [
  {
    followUpsFullDate: "9 July 2023",
    followUpsTime: "3:30PM",
    followUpsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    followUpsFullDate: "15 Aug 2023",
    followUpsTime: "5:00PM",
    followUpsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    followUpsFullDate: "9 Nov 2023",
    followUpsTime: "2:30PM",
    followUpsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    followUpsFullDate: "1 Nov 2023",
    followUpsTime: "11:30PM",
    followUpsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
];

// Workflow Profile Contact Log Meeting Data
export const profileContactLogMeetingData = [
  {
    meetingHeading: "Meeting",
    meetingFullDate: "15/10/23",
    meetingTime: "3:00PM",
    meetingNote:
      "Sed quisque elit odio scelerisque. Habitasse tortor a quisque gravida diam id. Mi sit id dui fringilla.",
  },
  {
    meetingHeading: "Meeting",
    meetingFullDate: "5/10/23",
    meetingTime: "6:00pm",
    meetingNote:
      "Sed quisque elit odio scelerisque. Habitasse tortor a quisque gravida diam id. Mi sit id dui fringilla.",
  },
  {
    meetingHeading: "Meeting",
    meetingFullDate: "2/10/23",
    meetingTime: "5:00pm",
    meetingNote:
      "Sed quisque elit odio scelerisque. Habitasse tortor a quisque gravida diam id. Mi sit id dui fringilla.",
  },
];

// Workflow Profile Contact Log ChatLogs Data
export const profileContactLogChatLogsData = [
  {
    chatLogsImg: bessieCooper,
    chatLogsName: "Bessie Cooper",
    chatLogsFullDate: "9 July 2023",
    chatLogsTime: "3:30PM",
    chatLogsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    chatLogsImg: jennyWilson,
    chatLogsName: "Bell Jerome",
    chatLogsFullDate: "9 July 2023",
    chatLogsTime: "3:30PM",
    chatLogsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    chatLogsImg: ralphEdwards,
    chatLogsName: "Benny Edwards",
    chatLogsFullDate: "9 July 2023",
    chatLogsTime: "3:30PM",
    chatLogsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
  {
    chatLogsImg: jennyWilson,
    chatLogsName: "Bobbi Wilson",
    chatLogsFullDate: "9 July 2023",
    chatLogsTime: "3:30PM",
    chatLogsText:
      "I contacted them on facebook messenger regarding their order status.",
  },
];

// Notificaiton Modal Data
export const notificaitonModalData = [
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
];

// Notificaiton Page Data
export const notificaitonPageData = [
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
  {
    notificationIcon: <BellIcon />,
    notificationText:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has",
  },
];

export const faqDataLeft = [
  {
    questions: "How do I clear follow ups?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I merge duplicate contacts?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "Can I see a list of what I completed today?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I add, delete or edit a TAG?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I update my payment method?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I clear follow ups?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
];
export const faqDataRight = [
  {
    questions: "How do I get my Facebook Friends into chatlott",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "Does chatlott send texts or Facebook messages?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I clear follow ups?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How come I can’t find the scripts I created in my account?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How can I be sure my information is safe?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
  {
    questions: "How do I upload my Instagram Followers?",
    answers:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio fugiat consectetur eum quisquam provident facere adipisci voluptatibus iure cupiditate.",
  },
];

//========== SETTINGS

export const accessAccountData = [
  {
    accessAccountBtn: "Facebook",
  },
  {
    accessAccountBtn: "MS Team",
  },
  {
    accessAccountBtn: "WhatsApp",
  },
  {
    accessAccountBtn: "Instagram",
  },
  {
    accessAccountBtn: "Snapchat",
  },
  {
    accessAccountBtn: "Facetime",
  },
  {
    accessAccountBtn: "Google Meet",
  },
  {
    accessAccountBtn: "Facetime",
  },
  {
    accessAccountBtn: "Zoom",
  },
  {
    accessAccountBtn: "Skype",
  },
];

// DropDown Data
export const AllConatactsDropdownData = [
  {
    selectValue: "Prospects",
    bgColor: "bg-[linear-gradient(180deg,_#27BAF9_0%,_#C5EDFE_100%)]",
    selectBgColor: "hidden",
    selectCustomHidden: "hidden",
    filterValue: "Prospect",
  },
  {
    selectValue: "Customers",
    bgColor: "bg-yesllo_gradient",
    selectBgColor: "hidden",
    selectCustomHidden: "hidden",
    filterValue: "Clients",
  },
  {
    selectValue: "Team Mates",
    bgColor: "bg-new_purpal",
    selectBgColor: "hidden",
    selectCustomHidden: "hidden",
    filterValue: "Team Member",
  },
  {
    selectCustom: "Add Custom",
    bgColor: "hidden",
    selectColorImg: addCustomColorImg,
    selectValueHidden: "hidden",
    filterValue: "Add New Type",
  },
];

// =============== DROPDOWN DATA
export const teamDropdownData = [
  {
    teamName: "Trading-Secrets",
  },
  // {
  //   teamName: "Heads of houses",
  // },
  {
    teamName: "SLT",
  },
  {
    teamName: "Pastoral staff",
  },
  // {
  //   teamName: "Academic Tutors",
  // },
  {
    teamName: "Heads of year",
  },
  {
    teamName: "Maths Team",
  },
];
